import { ref, computed, onMounted } from 'vue';
import { headerThemes } from '@/Config/headerThemes.js';
import { isDateInRange } from '@/Utils/holidayDates.js';

const activeTheme = ref(null);

export function useHeaderTheme() {
    onMounted(() => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        for (const theme of headerThemes) {
            if (isDateInRange(today, theme.from, theme.to)) {
                activeTheme.value = theme;
                break;
            }
        }
    });

    const headerStyle = computed(() => {
        if (!activeTheme.value) return {};
        const style = {};
        if (activeTheme.value.headerBg) {
            style.background = activeTheme.value.headerBg;
        }
        return style;
    });

    const gradientLineStyle = computed(() => {
        if (!activeTheme.value?.gradientLine) return {};
        return { background: activeTheme.value.gradientLine };
    });

    const accentOverride = computed(() => activeTheme.value?.accentOverride || null);

    const animationName = computed(() => activeTheme.value?.animation || null);
    const animationIntensity = computed(() => activeTheme.value?.animationIntensity || 'low');

    const themeLabel = computed(() => activeTheme.value?.label || null);

    return {
        activeTheme,
        headerStyle,
        gradientLineStyle,
        accentOverride,
        animationName,
        animationIntensity,
        themeLabel,
    };
}
